module.exports = __webpack_public_path__ + "static/media/Ricongiungimento.63ee4dbd.png";